export class JSONError extends Error {
  constructor(errorText = 'Not JSON response') {
    super(errorText);
    this.name = 'JSONError';
  }
}
